import { useReveal } from "../hooks/useReveal";
import { ParallaxBg } from "../components/ParallaxBg";
import { Accordion } from "../components/Accordion";
import { MODULES } from "../lib/copy";

export default function Curriculum() {
  const ref = useReveal();
  return (
    <section ref={ref} className="relative overflow-hidden py-28 md:py-36" data-testid="curriculum-section">
      <ParallaxBg image="/bg/home4.jpg" />
      <div className="relative max-w-[1100px] mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <p className="section-label mb-8 reveal-up">[005] — THE CURRICULUM</p>
            <h2 className="reveal-up font-black uppercase" style={{ fontSize: "clamp(28px, 3.6vw, 48px)", letterSpacing: "-0.02em" }}>
              GET A SNEAK PEEK<br />INTO THE WEBINAR
            </h2>
          </div>
          <p className="mono reveal-up" style={{ fontSize: 11, letterSpacing: "0.2em", color: "var(--muted)" }}>
            5 MODULES · 60 MINUTES TOTAL
          </p>
        </div>
        <div className="reveal-up">
          <Accordion items={MODULES} testPrefix="curriculum" />
        </div>
      </div>
    </section>
  );
}
